import { Box, styled } from '@mui/material'

export default styled(Box)(({ theme }) => ({
  width: '100%',
  borderRadius: theme.spacing(1.5),
  padding: theme.spacing(3),
  border: `1px solid ${theme.palette.divider}`
}))
